export const linksCopy = {
  openInNewWindow: '',
  accountSupport: '',
  ccpaYourPrivacyRights: '',
  ccpaConsumerPrivacyRights: '',
  ccpaDoNotSell: '',
  ccpaLimitUse: '',
  contact: '',
  dvrWatchTv: '',
  facebookLabel: '',
  linkedinLabel: '',
  guideWatchTv: '',
  homeSupport: '',
  instagramLabel: '',
  internetSupport: '',
  legalPolicies: '',
  libraryWatchTv: '',
  liveWatchTv: '',
  location: '',
  customerCommitment: '',
  energyUsage: '',
  mobileSupport: '',
  ondemandWatchTv: '',
  tvSupport: '',
  twitterLabel: '',
  voiceSupport: '',
  businessPhoneSupport: '',
  accessibilitySupport: '',
  weather: '',
  youtubeLabel: '',
  supportLink: '',
  accountSupportBurger: '',
  getSupport: '',
  watchTv: '',
  account: '',
  support: '',
  watch: '',
  accountAria: '',
  supportAria: '',
  socialMediaDescription: '',

  footerYourPrivacyRightLabel: '',
  footerCaliforniaConsumerPrivacyRightsLabel: '',
  footerDoNotSellOptOutLabel: '',
  footerServiceRateDisclosures: '',
  footerPoliciesLabel: '',
  footerCaliforniaLimitedUseOfSensitivePersonalInfoLabel: '',
  footerOpenSourceLibrariesLabel: '',
};
